<template>
  <main>
    <article>
      <div id="gettingToKnowMe" class="qrs-typography">
        <!-- 
         // View questionTopics
            -->
        <section id="questionTopics" v-if="display.includes('questionTopics')">
          <pageHeader>
            <h2 class="qrs-header-xl mt--0 mb--0">Getting to know me</h2>
          </pageHeader>
          <div v-if="!gettingToKnowMe.current || gettingToKnowMe.current.length < 1">
            <img class="m-auto d-block" alt="Introduction image" :src="logo" />
            <p>
              Here you can record information about yourself and your life
              story.
            </p>

            <p>
              You can share this information with anyone you want, for example,
              new people you meet who might be giving you support such as home
              care workers, and staff in hospitals and dementia groups.
            </p>

            <p>
              There are a few questions for each heading. You don't need to
              answer all the questions if you don't want to.
            </p>

            <button name="get started" aria-label="get started with getting to know me" class="govuk-button mt--24"
              @click="getStarted()">
              Get started
              <span class="screen-reader-text">get started with getting to know me</span>
            </button>

            <hr class="divider" />

            <h4>Email blank form</h4>
            <p class="mb--0">
              If you have a lot of information to enter, click on the link below
              to email a form to yourself. Then you can fill in the information
              on your computer instead of your phone or tablet.
            </p>

            <a name="Email blank form" aria-label="Download questions form"
              class="govuk-button govuk-button--neutral mt--24" target="_blank" style="color:#333333;"
              href="https://rightdecisions.scot.nhs.uk/medicinesdata/GettingtoKnowMeForm.pdf"
              title="Access the form to complete offline">
              Email blank form
            </a>

            <!-- <button
              name="Access form"
              aria-label="Download questions form"
              class="govuk-button govuk-button--secondary mt--24"
            >
              Access form
              <span class="screen-reader-text">Access questions form</span>
            </button> -->
          </div>
          <div v-if="gettingToKnowMe.current && gettingToKnowMe.current.length > 0">
            <!-- <button
              name="get started"
              aria-label="get started with getting to know me"
              class="govuk-button"
              @click="deleteTest()"
            >
              reset (test)
              <span class="screen-reader-text"
                >get started with getting to know me</span
              >
            </button> -->
            <button type="button" name="Share" aria-label="Share questions and answers" class="govuk-button"
              @click="displayClicked('share')">
              Share
              <span class="screen-reader-text">Share questions and answers</span>
            </button>
            <a name="Email blank form" aria-label="Download questions form" class="govuk-button govuk-button--neutral"
              target="_blank" style="color:#333333;"
              href="https://rightdecisions.scot.nhs.uk/medicinesdata/GettingtoKnowMeForm.pdf"
              title="Access the form to complete offline">
              Email blank form
            </a>
            <div v-for="(q, idx) in gettingToKnowMe.current[0].data" :key="idx" @click="viewQuestionSet(q)">
              <div class="item__panel">
                <div class="govuk-grid-row">
                  <div class="govuk-grid-column-full">
                    <div class="item__panel__header">
                      <h4 class="m-0">{{ q.name }}</h4>
                      <p class="mt--0">{{ q.info }}</p>
                      <span class="hdr__label" v-html="displaydate(
                        q.lastupdated,
                        gettingToKnowMe.current[0].datecreated
                      )
                        ">
                      </span>
                    </div>
                  </div>
                </div>
                <hr class="divider" />
                <div class="govuk-grid-row">
                  <div class="item__panel__content mb--0">
                    <div class="score govuk-grid-column-one-half">
                      <span class="label">Answered</span>
                      <p class="mb--0">
                        <strong>{{ q.progress }}/{{ q.questions.length }}</strong>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- // End -->

        <!-- 
         // View question set
            -->

        <section id="questionset" v-if="display.includes('questionset')">
          <pageHeader>
            <h2 class="qrs-header-xl mt--0 mb--0">{{ selectedQuestionSet.name }}</h2>
          </pageHeader>

          <div v-if="selectedQuestionSet.questions.length > 0">
            <div class="questions">
              <div class="question" v-for="(q, idx) in selectedQuestionSet.questions" :key="idx">
                <div class="question-body" v-if="idx == qidx">
                  <div class="question__nav mb--small clearfix">
                    <a v-if="idx > 0" @click="previousQuestion" class="govuk-back-link" role="button"
                      aria-label="go back to the previous screen">
                      <strong>Previous</strong>
                    </a>
                  </div>

                  <div class="clearfix mb--lg">
                    <label class="label">Question {{ q.qNo }}</label>
                    <div>
                      <p v-if="q.desc.length > 0">{{ q.desc }}</p>
                      <h3 class="govuk-label-wrapper mb--8">{{ q.name }}</h3>
                    </div>

                    <div v-if="q.type === 'textarea'" class="govuk-form-group mt--24">
                      <textarea class="govuk-textarea" id="content" v-model="q.content"></textarea>
                    </div>

                    <div v-if="q.type === 'radiobutton'">
                      <p v-if="q.title != null">
                        <strong>{{ q.title }}</strong>
                      </p>
                      <div class="govuk-form-group mt--24" v-for="(p, idx2) in selectedQuestionSet.questions[idx]
                        .prevalues" :key="idx2">
                        <fieldset v-if="p.type === 'radiobutton'" class="govuk-fieldset">
                          <div class="govuk-radios">
                            <div class="govuk-radios__item">
                              <input class="govuk-radios__input" type="radio" v-bind:id="combinetext('q', idx2)"
                                v-bind:name="combinetext('q', idx)" v-on:change="
                                  radioChange(
                                    selectedQuestionSet.questions[idx]
                                      .prevalues,
                                    idx2
                                  )
                                  " v-bind:value="p.name" :checked="p.selected" />
                              <label class="govuk-label govuk-radios__label" v-bind:for="combinetext('q', idx2)">
                                {{ p.name }}
                                <span v-if="p.desc">{{ p.desc }}</span>
                              </label>
                              <div v-if="p.child && p.selected" class="govuk-form-group mt--24">
                                <p>{{ p.child.name }}</p>
                                <textarea class="govuk-textarea" v-model="p.child.content"></textarea>
                              </div>
                            </div>
                          </div>
                        </fieldset>

                        <div v-if="p.type === 'textarea'">
                          <p>{{ p.name }}</p>
                          <textarea class="govuk-textarea" v-model="p.content" />
                        </div>
                      </div>
                    </div>

                    <div v-if="q.type === 'checkboxlist'">
                      <div class="govuk-form-group mt--24" v-for="(p, idx2) in selectedQuestionSet.questions[idx]
                        .prevalues" v-bind:key="idx2">
                        <fieldset class="govuk-fieldset" v-if="p.type === 'checkbox'">
                          <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                            <div class="govuk-checkboxes__item">
                              <input type="checkbox" class="govuk-checkboxes__input" v-bind:id="combinetext('q', idx2)"
                                v-bind:name="combinetext('q', idx2)" v-on:change="
                                  checkboxChange(
                                    selectedQuestionSet.questions[idx]
                                      .prevalues,
                                    idx2
                                  )
                                  " v-bind:value="p.name" v-bind:checked="p.selected" />
                              <label class="govuk-label govuk-checkboxes__label" v-bind:for="combinetext('q', idx2)">
                                {{ p.name }}
                              </label>
                              <div v-if="p.child && p.selected" class="govuk-form-group mt--24">
                                <p>{{ p.child.name }}</p>
                                <textarea class="govuk-textarea" v-model="p.child.content"></textarea>
                              </div>
                            </div>
                          </div>
                        </fieldset>

                        <div v-if="p.type === 'textarea'">
                          <p>{{ p.name }}</p>
                          <textarea class="govuk-textarea" v-model="p.content"></textarea>
                        </div>
                      </div>
                    </div>

                    <div v-if="q.type === 'select'">
                      <!-- <p v-if="q.prevalues[0].type === 'selectOption'">This is a select option</p> -->
                      <div v-if="q.prevalues[0].type === 'selectOption'">
                        <div class="govuk-form-group">
                          <label class="govuk-label" for="sort">
                            Select item
                          </label>
                          <select class="govuk-select" id="select" name="select" v-on:change="
                            selectChange(
                              selectedQuestionSet.questions[idx].prevalues,
                              idx
                            )
                            ">
                            <optgroup value="">
                              <option disabled selected value="">
                                Please select one
                              </option>
                            </optgroup>
                            <optgroup v-for="(p, idx2) in selectedQuestionSet.questions[
                              idx
                            ].prevalues" :key="idx2" v-bind:value="p.name">
                              <option v-if="p.type === 'selectOption'" v-bind:id="combinetext('q', idx2)"
                                v-bind:name="combinetext('q', idx2)" v-bind:value="p.name" v-bind:selected="p.selected">
                                {{ p.name }}
                              </option>
                              <div v-if="p.child && p.selected" class="govuk-form-group mt--24">
                                <p>{{ p.child.name }}</p>
                                <textarea class="govuk-textarea" v-model="p.child.content"></textarea>
                              </div>
                            </optgroup>
                          </select>
                        </div>
                      </div>

                      <div v-for="(p, idx2) in selectedQuestionSet.questions[idx]
                        .prevalues" :key="idx2">
                        <div v-if="p.type === 'textarea'">
                          <hr class="divider" />
                          <p>{{ p.name }}</p>
                          <textarea class="govuk-textarea" v-model="p.content"></textarea>
                        </div>
                        <!-- <div class="govuk-form-group mt--24">
                        <select
                          name="religiousBeliefs"
                          class="form-control"
                          id="religiousBeliefs"
                        >
                        <option v-for="(p, idx2) in selectedQuestionSet.questions[idx].prevalues" :key="idx2">{{p.name}}</option>
                        </select>
                      </div> -->
                      </div>
                    </div>
                  </div>

                  <button v-if="qidx < selectedQuestionSet.questions.length - 1" @click="nextQuestion" name="Continue"
                    aria-label="Continue to next question" class="govuk-button govuk-button--secondary mt--24">
                    Continue
                    <span class="screen-reader-text">Continue to next question</span>
                  </button>
                  <button v-if="idx === selectedQuestionSet.questions.length - 1" @click="saveQuestionSet"
                    name="Save and continue" aria-label="Save question answers"
                    class="govuk-button govuk-button--secondary mt--24">
                    Save and continue
                    <span class="screen-reader-text">Save question answers</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- // End -->

        <!-- 
         // Share
            -->
        <section id="share" v-if="display.includes('share')">
          <pageHeader>
            <h2 class="qrs-header-xl mt--0 mb--0">Share</h2>
          </pageHeader>
          <div class="share_initial" v-if="!share">
            <div class="question__nav mb--small clearfix">
              <a @click="displayClicked('questionTopics')" class="govuk-back-link" role="button"
                aria-label="go back to the previous screen">
                <strong>Previous</strong>
              </a>
            </div>
            <p>
              You can email your
              <strong>"Getting to know me"</strong> information to people who
              can help you to stay well.
            </p>

            <p>
              For example - a family member, a carer, a healthcare professional.
            </p>

            <p>You will need to know their email address.</p>

            <button type="button" name="Share via email" aria-label="Share my information via email"
              class="govuk-button govuk-button--secondary mt--24" @click="GoToshareViaEmail()">
              Share via email
              <span class="screen-reader-text">Share my information via email</span>
            </button>
          </div>

          <div class="share_screen" v-if="share">
            <div id="email-sent" style="display: none">
              <div class="question__nav mb--small clearfix">
                <a @click="cancelShare()" class="govuk-back-link" role="button"
                  aria-label="go back to the previous screen">
                  <strong>Previous</strong>
                </a>
              </div>
              <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                data-module="govuk-notification-banner">
                <div class="govuk-notification-banner__header">
                  <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                    Your email has been sent.
                  </h2>
                </div>
                <div class="govuk-notification-banner__content">
                  <p class="govuk-notification-banner__heading">
                    If the person to whom you sent the email does not receive
                    it, please:
                  </p>
                  <ol type="a">
                    <li>Check the email address.</li>
                    <li>
                      Ask them to check their spam or junk folders. Note that
                      they may need to transfer the email to their normal inbox
                      in order to view the attached report.
                    </li>
                    <li>
                      Ask them to add
                      <a href="mailto:noreply@tactuum.com">noreply@tactuum.com</a>
                      to their email whitelist.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
            <div id="email-error-send" style="display: none" class="govuk-error-summary"
              aria-labelledby="error-summary-title" role="alert" tabindex="-1" data-module="govuk-error-summary">
              <h2 class="govuk-error-summary__title" id="error-summary-title">
                Email was not sent
              </h2>
              <div class="govuk-error-summary__body">
                <p>Please try again</p>
              </div>
            </div>
            <div id="email-error" style="display: none" class="govuk-error-summary" aria-labelledby="error-summary-title"
              role="alert" tabindex="-1" data-module="govuk-error-summary">
              <h2 class="govuk-error-summary__title" id="error-summary-title">
                Email was not sent
              </h2>
              <div class="govuk-error-summary__body" v-if="this.nameError">
                <p>Please check the name that you entered and try again.</p>
              </div>
              <div class="govuk-error-summary__body" v-if="this.emailAddressError">
                <p>
                  Please check the email address that you entered and try again.
                </p>
              </div>
              <div class="govuk-error-summary__body" v-if="this.recipientsError">
                <p>
                  Please check the recipient email(s) that you entered and try
                  again.
                </p>
              </div>
            </div>
            <div class="share_form" id="share_form">
              <p>
                Please enter the email address to send your
                <strong>"Getting to know me"</strong> PDF to, as well as your
                name.
              </p>

              <div class="govuk-form-group">
                <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                  <h1 class="govuk-fieldset__heading" id="name-label">
                    Your name*
                  </h1>
                </legend>
                <input v-model="name" type="text" id="name-input" class="govuk-input" />
              </div>

              <div class="govuk-form-group">
                <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                  <h1 class="govuk-fieldset__heading" id="yourEmail-label">
                    Your email address*
                  </h1>
                </legend>
                <input v-model="emailAddress" type="email" id="yourEmail-input" class="govuk-input" />
              </div>

              <div class="govuk-form-group">
                <legend class="govuk-fieldset__legend govuk-fieldset__legend--m">
                  <h1 class="govuk-fieldset__heading" id="emailRecipient-label">
                    Recipient email*
                  </h1>
                </legend>
                <div id="email-hint" class="govuk-hint">
                  To add multiple recipients, enter an email address and tap on
                  'Add recipient'
                </div>
                <input v-model="emailRecipient" type="email" id="emailRecipient-input" aria-label="recipients"
                  class="govuk-input" />
                <div class="govuk-button--disabled" v-if="!validRecipient">
                  <button name="Add email recipient" aria-label="Add email recipient"
                    class="govuk-button govuk-button--secondary mt--24 mb--16" @click="addEmail()">
                    Add recipient
                    <span class="screen-reader-text">Add email recipient</span>
                  </button>
                </div>
                <div class="" v-if="validRecipient">
                  <button name="Add email recipient" aria-label="Add email recipient"
                    class="govuk-button govuk-button--secondary mt--24 mb--16" @click="addEmail()">
                    Add recipient
                    <span class="screen-reader-text">Add email recipient</span>
                  </button>
                </div>
                <div v-if="recipients.length >= 1" class="emails freetext__panel mb--16">
                  <span><strong>Recipients:</strong></span>
                  <div class="emailtag freetext__panel__item" v-for="(e, idx) in recipients" @click="removeEmail(idx)"
                    :key="idx">
                    <span class="emailname">{{ e }}</span>
                    <span class="deletex freetext__panel__button"><i class="fa fa-close"></i></span>
                  </div>
                </div>
                <hr class="divider" />
              </div>

              <button name="share-button" aria-label="share-button" class="govuk-button mt--24"
                title="Use this button to share via email" @click="shareViaEmail()">
                <span v-if="!emailSending">Submit</span>
                <span v-if="emailSending">Sending <i class="fa fa-circle-o-notch fa-spin"></i></span>
              </button>
              <button name="cancel-button" aria-label="cancel-button" class="govuk-button govuk-button--neutral"
                title="Use this button to cancel the action" @click="cancelShare()">
                Cancel
              </button>
            </div>
          </div>
        </section>

        <!-- // End -->

        <section id="loading" v-if="display.includes('loading')">
          <pageHeader>
            <h1 class="qrs-header-xl">Getting to know me</h1>
          </pageHeader>
          <div>
            <div class="loader"></div>
            <p class="loading__text">Saving...</p>
          </div>
        </section>
      </div>
    </article>
  </main>
</template>

<script>
import CryptoJS from "crypto-js";
//import axios from "axios";
import { QuestionTopics } from "../../App_Data/gettingToKnowMeData.json";
import helper from "../../helpers/helper.js";
import pdfhelper from "../../helpers/pdfhelper.js";
import logo from '../../helpers/encodedImages.js';

const INAPP = "--INAPP--";

// const DISPLAY_INTRO = "intro";
const DISPLAY_QUESTIONTOPICS = "questionTopics";
const DISPLAY_QUESTIONSET = "questionset";
const DISPLAY_LOADING = "loading";

export default {
  name: "Home",
  mounted() {
    setTimeout(
      function () {
        let bodyhtml = document.querySelector("body").innerHTML;
        if (!bodyhtml.includes(INAPP)) {
          this.isapp = false;
          this.rootpath = "/";
        }
      }.bind(this),
      500
    );
    this.initdate = new Date(1945, 0); //new Date(_d.getFullYear() - 70, 0);
    this.getSavedData();
    console.log(this.isapp);
  },
  data() {
    return {
      logo: logo.introductionLogo,
      isapp: true,
      encrypted: "",
      unencrypted: "",
      rootpath: "",
      name: "",
      nameError: false,
      emailAddress: "",
      emailAddressError: false,
      emailRecipient: "",
      recipients: [{ emaill: "mmurray@tactuum.com", name: "Matthew Murray" }],
      recipientsError: false,
      emailSending: false,
      validRecipient: null,
      share: false,
      shareActive: false,
      newDate: null,
      display: DISPLAY_QUESTIONTOPICS,
      questionTopics: QuestionTopics,
      topicsList: {},
      selectedQuestionSet: {},
      gettingToKnowMe: { current: [] },
      qidx: 0,
      next_idx: 1,
      prev_idx: 0,
      selected_count: 0,
      datestate: {
        disabledDates: {
          customPredictor: function (date) {
            let _currentdate = new Date();
            let _year0 = _currentdate.getFullYear() - 110;
            let _year1 = _currentdate.getFullYear();
            let _year = date.getFullYear();
            if (_year <= _year0 || _year >= _year1) {
              return true;
            }
          },
        },
      },
      initdate: {},
    };
  },
  watch: {
    emailRecipient(value) {
      console.log(value);
      this.emailRecipient = value;
      this.validateRecipientEmail(value);
    },
  },
  methods: {
    ...helper,

    externalLinkClicked(url) {
      if (this.isapp) {
        let d = { title: "", nodeid: -1, href: "", target: "" };
        d.href = url;
        d.target = "_blank";
        window.Native("dataCallback", d);
        return false;
      } else {
        let win = window.open(url, "_blank");
        win.focus();
      }
    },
    applyPath(path) {
      return this.rootpath + path;
    },
    validateRecipientEmail(value) {
      if (
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        )
      ) {
        this.validRecipient = true;
      } else {
        this.validRecipient = false;
      }
    },
    validateEmail(email) {
      const re =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    validateForm() {
      let errorMessage = document.getElementById("email-error");
      let nameLabel = document.getElementById("name-label");
      let emailLabel = document.getElementById("yourEmail-label");
      let recipientLabel = document.getElementById("emailRecipient-label");

      let validForm = false;

      let _hasre = false;
      let _tempentry = this.emailRecipient.trim();

      let regex =
        /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (this.name == undefined || this.name == null || this.name.length == 0) {
        nameLabel.style.color = "red";
        this.nameError = true;
        validForm = false;
        window.scrollTo(0, top);
      } else {
        nameLabel.style.color = "black";
        this.nameError = false;
        validForm = true;
      }

      if (this.emailAddress == undefined || this.emailAddress == null || this.emailAddress.length == 0 || !this.emailAddress.match(regex)) {
        emailLabel.style.color = "red";
        this.emailAddressError = true;
        validForm = false;
        window.scrollTo(0, top);
      } else {
        emailLabel.style.color = "black";
        this.emailAddressError = false;
        validForm = true;
      }

      this.emailRecipient = _tempentry;
      if (this.validateEmail(this.emailRecipient)) {
        _hasre = true;
      }
      if (_hasre && this.recipients.length < 1) {
        this.recipients.push(this.emailRecipient);
      }
      if (this.recipients.length < 1 && !_hasre) {
        recipientLabel.style.color = "red";
        window.scrollTo(0, top);
        this.recipientsError = true;
        validForm = false;
      } else {
        recipientLabel.style.color = "black";
        this.recipientsError = false;
        validForm = true;
      }

      if (this.nameError || this.emailAddressError || this.recipientsError) {
        console.log("all fields error");
        errorMessage.style.display = "block";
        window.scrollTo(0, top);
        validForm = false;
      } else {
        errorMessage.style.display = "none";
        validForm = true;
      }

      if (validForm) {
        this.sendEmail();
      } else {
        console.log("Not valid Form");
      }
    },
    removeEmail(idx) {
      this.recipients.splice(idx, 1);
    },
    resetForm() {
      this.name = "";
      this.emailAddress = "";
      this.emailRecipient = "";
      this.recipients = [];
      this.emailSending = false;
    },
    addEmail() {
      console.log("add email called");
      let rep = this.emailRecipient.trim();
      if (this.validateEmail(rep)) {
        this.emailRecipient = "";
        let _eexist = false;
        this.recipients.forEach((e) => {
          if (rep.toLowerCase() === e.toLowerCase()) {
            _eexist = true;
          }
        });
        if (!_eexist) {
          this.recipients.push(rep);
          console.log(this.recipients);
        }
      }
      // this.validateForm();
    },
    getAnswer(pv) {
      let _ans = [];
      pv.forEach((v) => {
        if (v.selected) {
          _ans.push(v.name);
          if (v.child && v.child.content && v.child.content.length > 0) {
            _ans.push(v.child.content);
          }
        }
        if (v.type === "textarea" && v.content && v.content.length > 0) {
          _ans.push(v.content);
        }
      });
      return _ans.join(",");
    },
    getAnswer2(pv) {
      let _ans = [];
      pv.forEach((v) => {
        if (v.selected) {
          _ans.push(v.name);
          if (v.child && v.child.content && v.child.content.length > 0) {
            _ans.push(v.child.content);
          }
        }
        if (v.type === "textarea" && v.content && v.content.length > 0) {
          _ans.push(" Freetext response : " + v.content);
        }
      });
      return _ans.join(",");
    },
    displayClicked(display) {
      this.display = display;
      window.scrollTo(0, top);
    },
    cancelClicked() {
      // this.displayClicked(DISPLAY_GETTINGTOKNOWME);
      this.displayClicked(DISPLAY_QUESTIONTOPICS);
      this.qidx = 0;
      window.scrollTo(0, top);
    },
    cancelShare() {
      this.share = false;
      this.resetForm();
    },
    shareViaEmail() {
      console.log("Share via email clicked");
      this.validateForm();
      // this.sendEmail();
    },
    GoToshareViaEmail() {
      console.log("Go to share screen");
      this.share = true;
      this.resetForm();
    },
    nextQuestion() {
      if (this.selectedQuestionSet.questions.length - 1 > this.qidx) {
        this.prev_idx = this.qidx;

        let _p = this.selectedQuestionSet.questions[this.qidx].prevalues.find(
          (p) => p.selected
        );

        if (_p && _p.next) {
          this.selectedQuestionSet.questions.forEach((q, i) => {
            if (q.id === _p.next) {
              this.prev_idx = this.qidx;
              this.qidx = i;
            }
          });
        } else {
          this.prev_idx = this.qidx;
          this.qidx++;
        }
      }
      window.scrollTo(0, top);
    },
    previousQuestion() {
      if (this.prev_idx > -1) {
        if (this.qidx == this.prev_idx) {
          this.qidx--;
        } else {
          this.qidx = this.prev_idx;
        }
        if (this.qidx - 1 > -1) {
          this.prev_idx = this.qidx - 1;
        }
      }
      window.scrollTo(0, top);
    },
    selectChange(prevalues, idx) {
      console.log("selected value changed");
      let _hasnext = false;
      prevalues.forEach((el, i) => {
        if (el.next) {
          _hasnext = true;
        }
        if (i === idx) {
          el.selected = true;
        } else {
          el.selected = false;
        }
      });
      if (_hasnext) {
        this.resetQuestionsAfterCurrent();
      }
      this.updateProgress();
    },
    radioChange(prevalues, idx) {
      let _hasnext = false;
      prevalues.forEach((el, i) => {
        if (el.next) {
          _hasnext = true;
        }
        if (i === idx) {
          el.selected = true;
        } else {
          el.selected = false;
        }
      });
      if (_hasnext) {
        this.resetQuestionsAfterCurrent();
      }
      this.updateProgress();
    },
    checkboxChange(prevalues, idx) {
      let _maxcount = -1;
      if (this.selectedQuestionSet.questions[this.qidx].max_selected_values) {
        _maxcount =
          this.selectedQuestionSet.questions[this.qidx].max_selected_values;
      }
      let _hasnext = false;
      let _tempmaxcount = 0;
      prevalues.forEach((el, i) => {
        if (el.next) {
          _hasnext = true;
        }
        if (i === idx) {
          if (el.selected) {
            el.selected = false;
          } else {
            el.selected = true;
          }
        }
      });
      if (_maxcount > 0) {
        prevalues.forEach((el) => {
          if (el.selected) {
            _tempmaxcount++;
          }
          if (_tempmaxcount > _maxcount) {
            el.selected = false;
          }
        });
      }

      if (_hasnext) {
        this.resetQuestionsAfterCurrent();
      }
      this.selected_count = _tempmaxcount;
      this.updateProgress();
    },
    resetQuestionsAfterCurrent() {
      for (
        let i = this.qidx + 1;
        i < this.selectedQuestionSet.questions.length;
        i++
      ) {
        this.selectedQuestionSet.questions[i].prevalues.forEach((p) => {
          if (p.type === "texarea") {
            p.content = "";
          }
          if (
            p.type === "radiobutton" ||
            p.type === "checkbox" ||
            p.type === "selectOption"
          ) {
            p.selected = false;
            if (p.child && p.child.type === "textarea") {
              p.child.content = "";
            }
          }
        });
      }
    },
    updateProgress() {
      if (
        this.gettingToKnowMe.current &&
        this.gettingToKnowMe.current.length > 0
      ) {
        let el = this.gettingToKnowMe.current[0];
        el.data.forEach((section) => {
          let _cnt1 = 0;
          section.questions.forEach((q) => {
            let _qanswered = false;
            if (q.type === "textarea" && q.content.length > 0) {
              _qanswered = true;
            } else if (
              (q.type === "radiobutton" ||
                q.type === "checkbox" ||
                q.type === "select") &&
              q.selected
            ) {
              _qanswered = true;
            }
            q.prevalues.forEach((p) => {
              if (p.type === "textarea" && p.content.length > 0) {
                _qanswered = true;
              } else if (
                (p.type === "radiobutton" ||
                  p.type === "checkbox" ||
                  p.type === "selectOption") &&
                p.selected
              ) {
                _qanswered = true;
              }
            });
            if (_qanswered) {
              _cnt1++;
            }
          });
          section.progress = _cnt1;
        });
      }
    },
    viewQuestionSet(q) {
      this.selectedQuestionSet = q;
      this.displayClicked(DISPLAY_QUESTIONSET);
      this.qidx = 0;
    },
    getStarted() {
      this.gettingToKnowMe.current = [];
      this.createQuestionTopicsSet();
      this.newDate = null;
    },
    createQuestionTopicsSet() {
      let string = JSON.stringify(this.questionTopics);
      let _currentTime = helper.getcurrentdate();
      let topic = JSON.parse(string);
      topic.name = this.newDate;
      topic.datecreated = _currentTime;
      topic.lastupdated = _currentTime;
      topic.sortbydate = helper.getcurrentdateasnumber();
      this.gettingToKnowMe.current.push(topic);
      this.displayClicked(DISPLAY_QUESTIONTOPICS);
      this.qidx = 0;
      this.updateProgress();
      this.saveData();
    },
    deleteTest() {
      this.gettingToKnowMe.current = [];
      this.updateProgress();
      this.saveData();
    },
    getSavedData() {
      let _me = this;
      if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
        window.flutter_inappwebview.callHandler = function () {
          var _callHandlerID = setTimeout(function () { });
          window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
          return new Promise(function (resolve, reject) {
            console.log(typeof (reject)); //this line is just to avoid unused variable error
            window.flutter_inappwebview[_callHandlerID] = resolve;
          });
        };
      }
      window.flutter_inappwebview.callHandler('GET:POLYREVIEW').then(function (result) {
        let res0 = atob(result);
        let res1 = JSON.parse(decodeURIComponent(res0));
        if (res0 === "%5B%5D") {
          _me.gettingToKnowMe = {
            current: [],
          };
        } else {
          _me.gettingToKnowMe.current = res1.current;
          _me.displayClicked(DISPLAY_QUESTIONTOPICS);
        }
        _me.updateProgress();
      }).catch((error) => {
        console.log('failed' + error);
        _me.gettingToKnowMe = {
          current: [],
        };
        _me.updateProgress();
      });
    },
    saveQuestionSet() {
      this.displayClicked(DISPLAY_LOADING);
      setTimeout(() => {
        let currentdatetime = helper.getcurrentdate();
        this.topicsList.lastupdated = currentdatetime;
        this.selectedQuestionSet.lastupdated = currentdatetime;
        this.selectedQuestionSet.completed = true;
        this.saveData();
        this.displayClicked(DISPLAY_QUESTIONTOPICS);
        this.updateProgress();
      }, 1000);
    },
    saveData() {
      let data1 = JSON.stringify(this.gettingToKnowMe);
      console.log("savereview called");
      let data2 = btoa(data1);
      let data0 = data2;
      console.log("data generated");
      console.log(data0);
      //alert("SAVE:POLYREVIEW:" + data0);
      if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
        window.flutter_inappwebview.callHandler = function () {
          var _callHandlerID = setTimeout(function () { });
          window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
          return new Promise(function (resolve, reject) {
            console.log(typeof (reject)); //this line is just to avoid unused variable error
            window.flutter_inappwebview[_callHandlerID] = resolve;
          });
        };
      }
      window.flutter_inappwebview.callHandler('SAVE:POLYREVIEW', data0).then(function (result) {
        return result;
      }).catch((error) => {
        console.log('failed' + error);
      });
    },
    sendEmail() {
      console.log("send email clicked");
      this.emailSending = true;
      console.log("email is sending...");
      let success = document.getElementById("email-sent");
      let errorMessage = document.getElementById("email-error-send");
      let shareForm = document.getElementById("share_form");

      let info = {
        name: this.name,
        email: this.emailAddress,
        date: helper.getcurrentdate()
      };
      let doc = pdfhelper.generateHtmlforPdf(
        info,
        this.gettingToKnowMe.current[0].data
      );
      //console.log(pdfhtml);
      let base64pdf = doc.output("datauri").replace('data:application/pdf;filename=generated.pdf;base64,','');
      // let _date = helper.getcurrentdateasnumber();

      let htmlbody =
        '<p>This form has been sent by an individual using the <a href="https://dementiawellbeing.scot.nhs.uk/" clicktracking="off" target="_blank" title="Living Well with Dementia">Living Well with Dementia</a> app provided by Inverclyde Health and Social Care Partnership.</p> <p>This app has been developed using the Right Decision Service provided by the Digital Health and Care Innovation Centre.</p> <p>If you experience any problems with receipt of this form or message, please contact decisionsupport@dhi-scotland.com. Please do not send person-identifiable information to this email address.</p>' +
        "<p><strong>Sender's name : </strong>" +
        info.name +
        "</p>";

      var model = {
        smtp: "smtp.sendgrid.net",
        port: 587,
        sendgrid_username: "apikey",
        sendgrid_password: "###SENDGRID###",
        to: [],
        from: {
          email: "noreply@tactuum.com",
          name: "Decision Support",
        },
        replyto: [
          {
            email: this.emailAddress,
            name: this.name,
          },
        ],
        subject: "Getting to know me report",
        // body: btoa(htmlbody),
        body: htmlbody,
        attachments: [],
        response_title: "Email sent",
        response_body: "Your email with attachment has been sent successfully",
        response_buttontext: "Ok",
      };

      model.attachments.push({
        filename: "GettingToKnowMe_Report.pdf",
        mimetype: "application/pdf",
        base64data: base64pdf,
      });

      model.to.push({ email: this.emailAddress, name: this.emailAddress });

      this.recipients.forEach((em) => {
        model.to.push({ email: em, name: em });
      });

      console.log("emails sent to:" + " " + model.to[1]);

      let _unencrypted = JSON.stringify(model);
      //let _encrypted = this.encrypt(_unencrypted).toString();
      let _temp = btoa(_unencrypted.toString());
      if (!window.flutter_inappwebview.callHandler) { //this instantiates some methods so that on android the loading works
            window.flutter_inappwebview.callHandler = function () {
              var _callHandlerID = setTimeout(function () { });
              window.flutter_inappwebview._callHandler(arguments[0], _callHandlerID, JSON.stringify(Array.prototype.slice.call(arguments, 1)));
              return new Promise(function (resolve, reject) {
                console.log(typeof (reject)); //this line is just to avoid unused variable error
                window.flutter_inappwebview[_callHandlerID] = resolve;
              });
            };
          }
          window.flutter_inappwebview.callHandler('SHARE', _temp).then(function(result) {
            if (result == "error") {
              console.log(result);
              console.log("failed!");
              window.scrollTo(0, top);
              errorMessage.style.display = "block";
              this.emailSending = false;
              
            } else {
              console.log("success");
            console.log(result);
            window.scrollTo(0, top);
            success.style.display = "block";
            shareForm.style.display = "none";
            }
            //this.resetForm();
                
            }).catch((error) => {
              console.log(error);
              console.log("failed!");
            window.scrollTo(0, top);
            errorMessage.style.display = "block";
            this.emailSending = false;
      });
    //   axios
    //     .post(
    //       "https://tac-dhi-ivflu-liv.azurewebsites.net/umbraco/surface/review/sendreview/?key=" +
    //       applicationKey,
    //       { data: "'" + _temp.toString() + "'" },
    //       {
    //         headers: {
    //           "Content-Type": "application/x-www-form-urlencoded",
    //           Origin: "http://localhost:8989",
    //         },
    //       }
    //     )
    //     .then((r) => {
    //       console.log("response:" + " " + r);
    //       console.log(r.status);
    //       console.log(r.data);

    //       if (r.status === 200 && r.data === "success") {
    //         console.log("success");
    //         window.scrollTo(0, top);
    //         success.style.display = "block";
    //         shareForm.style.display = "none";
    //         this.resetForm();
    //       } else {
    //         console.log("failed!");
    //         window.scrollTo(0, top);
    //         errorMessage.style.display = "block";
    //         this.emailSending = false;
    //       }
    //     })
    //     .catch((error) => {
    //       window.scrollTo(0, top);
    //       errorMessage.style.display = "block";
    //       this.emailSending = false;
    //       console.log("failed2" + error);
    //     });
   },
    encrypt(message) {
      let res = "";
      var secret = "###SELECTPDF###";
      var key = CryptoJS.enc.Utf8.parse(secret);
      var iv = CryptoJS.enc.Utf8.parse(secret);
      res = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(message), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return res;
    },
    decrypt(encrypted) {
      let res = "";
      let secret = "###SELECTPDF###";
      let key = CryptoJS.enc.Utf8.parse(secret);
      let iv = CryptoJS.enc.Utf8.parse(secret);
      var bytes = CryptoJS.AES.decrypt(encrypted, key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      res = bytes.toString(CryptoJS.enc.Utf8);
      return res;
    },
  },
};
</script>

